import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createMetaManager } from 'vue-meta'
import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faCheck,
  faExclamationTriangle,
  faTimes,
  faCircleInfo,
} from '@fortawesome/free-solid-svg-icons'
import { faCopy } from '@fortawesome/free-regular-svg-icons'
import { createI18nInstance } from '@/plugins/i18n'
import { useLoading } from '@/components/common/loading-overlay/useLoading'
import cookieBannerPlugin from '@/silktide/plugins/cookieBanner'
import './main.css'

async function bootstrapApp() {
  const { showLoading, hideLoading } = useLoading()
  showLoading()

  try {
    const i18n = await createI18nInstance()
    if (!i18n || typeof i18n !== 'object') {
      throw new Error('[i18n] Failed to initialize')
    }

    const pinia = createPinia()
    pinia.use(
      createPersistedState({
        storage: sessionStorage,
        key: (key) => `MYREGISTER_v${process.env.VERSION}_STORE_${key}`,
      }),
    )

    library.add(faCheck, faExclamationTriangle, faTimes, faCopy, faCircleInfo)

    console.log('Githash:', process.env.GIT_HASH)
    // console.log('Enable Camera:', appConfig.camera.enable)

    const app = createApp(App)
    app.component('fa', FontAwesomeIcon)
    app.use(pinia)
    app.use(i18n)
    app.use(router)
    app.use(createMetaManager())
    app.use(cookieBannerPlugin)
    app.mount('#app')
    window.dispatchEvent(new Event('vue-ready'))
  } catch (err) {
    console.error('[App] Failed to bootstrap:', err)
  } finally {
    hideLoading()
  }
}

bootstrapApp()
